import { useState, useEffect } from "react";
import { useLocation } from "react-router";

export default function useGetPath() {
  const [path, setPath] = useState("");
  const fcm = localStorage.getItem("fcm");
  const version = localStorage.getItem("version");

  const { pathname } = useLocation();

  useEffect(() => {
    setPath(
      `${pathname}${fcm !== "null" ? `?fcmToken=${fcm}` : ""}${
        version !== "null" ? `&version=${parseFloat(version)}` : ""
      }`
    );
  }, [pathname]);

  return { path };
}
